<script setup>

import GalleryHeading from "@/views/gallery/components/GalleryHeading.vue";
import GalleryContent from "@/views/gallery/components/GalleryContent.vue";
import {getCurrentInstance, onMounted, reactive} from "vue";
const { $axios } = getCurrentInstance().appContext.config.globalProperties;
const { $endpoint } = getCurrentInstance().appContext.config.globalProperties;
const galleryPageData = reactive({});
function normalizeGalleryData(raw) {
  return Object.values(raw)
      .filter(item => item && typeof item === "object" && "id" in item)
      .map(item => ({
        id: item.id,
        documentId: item.documentId,
        createdAt: item.createdAt,
        updatedAt: item.updatedAt,
        publishedAt: item.publishedAt,
        type: {
          id: item.galery_picture_type.id,
          label: item.galery_picture_type.label,
          uid: item.galery_picture_type.uid
        },
        images: item.galeryImages.map(img => ({
          name: img.name,
          url: img.url,
          width: img.width,
          height: img.height,
          size: img.size
        }))
      }))
}
onMounted(()=>{
  $axios.get($endpoint.LoadGallery).then((resp_gallery_data)=>{
    const rawTypes = resp_gallery_data.data.types   // adjust to the exact path of this object
    const rawImgList = resp_gallery_data.data.imagesList   // adjust to the exact path of this object

    // Convert {0:{},1:{},…} → [{}, {}, …] and filter only numeric keys
    const typesArray = Object.keys(rawTypes)
        .filter((k) => !isNaN(Number(k)))
        .map((k) => rawTypes[k])
    const imgListArray = normalizeGalleryData(rawImgList)
    const finalFormatedGalleries = imgListArray.flatMap((g) =>
        g.images.map((img) => ({
          type: String(g.type.uid),
          title: g.type.label,
          desc: g.type.uid,
          url: img.url
        }))
    )
    // Assign back to your reactive state
    Object.assign(galleryPageData, {
      ...resp_gallery_data.data,
      types: typesArray,
      imagesList: finalFormatedGalleries
    })
  })
  });
</script>

<template>
  <gallery-heading v-if="galleryPageData && galleryPageData.hero?.heroSection" :hero-infos="galleryPageData?.hero?.heroSection"></gallery-heading>
  <gallery-content v-if="galleryPageData && galleryPageData.imagesList?.length && galleryPageData.types?.length"
                   :gallery-types="galleryPageData.types" :galleries="galleryPageData.imagesList"></gallery-content>
</template>

<style scoped>

</style>